export enum PROPOSAL_STATUS_ENUM {
  RASCUNHO = 1,
  ENVIADA = 2,
  EM_ANDAMENTO = 3,
  ACEITA = 4,
  RECUSADA = 5,
  INICIADA = 6,
  FINALIZADA = 7,
}
